import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { BusyStateIndicator } from '../BusyStateIndicator';
import { useNotifyClosing } from '../BusyStateIndicator/__internal__/useNotifyClosing';
import { BaseDialog } from '../Dialog/__internal__/';
import bundle from './NovaComponents-BusyStateDialog-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const BusyStateDialog = props => {
  const localize = useTextLocalizer();
  useNotifyClosing({
    isOpen: props.isOpen,
    message: props.dialogDismissedMsg ?? localize('dialogDismissed.msg')
  });
  return /*#__PURE__*/_jsx(BaseDialog, {
    testId: props.testId,
    isOpen: props.isOpen,
    title: props.title && props.title.length > 0 ? props.title : localize('dialog.default.title'),
    contentPadding: "2rem",
    hideCloseIcon: true,
    dismissAction: props.showCancelButton ? {
      text: localize('dismiss.button.label'),
      onPress: props.onDismiss,
      ariaLabel: props.cancelAriaLabel
    } : undefined,
    size: {
      minWidth: '11rem',
      maxWidth: '24rem',
      minHeight: '0'
    },
    titleWrapText: true,
    focusLockProps: props.focusLockProps,
    children: /*#__PURE__*/_jsx(BusyStateIndicator, {
      active: true,
      delay: 0,
      ariaLabel: props.busyIndicatorAriaLabel
      // When busy dialog is opened, the focus hasn't been moved to the busy state indicator
      // yet, which causes BusyStateIndicator to announce "Processing" by deafult.
      // Since the focus will be set to it eventually to announce its aria-label, explicitly suppress the direct speech
      // announcement to avoid duplicate announcement.
      ,
      activeMsg: ""
    })
  });
};
//# sourceMappingURL=BusyStateDialog.js.map